export enum ContactFlagRequestAction {
  Add = 'Add',
  Delete = 'Delete',
}

export enum ContactFlagRequestStatus {
  New = 'New',
  Done = 'Done',
  WIP = 'WIP',
  Rejected = 'Rejected',
}
